import React from 'react';
import {Form, Edit, Flex, List} from 'components';
import {useNamedSelector} from 'helpers';

export function PassionInquiry2() {
  return (
    <Form {...useNamedSelector('identity.form', { name: 'passion-inquiry-2' })}>
      <List tiny-gutter>
        <List.Title>What would you choose to do or experience in your life right now if there were no restrictions or limitations?</List.Title>
        <Flex even stack>
          <Edit name="1" />
          <Edit name="2" />
        </Flex>
        <List.Title>What would you like to do when you retire?</List.Title>
        <Flex even stack>
          <Edit name="3" />
          <Edit name="4" />
        </Flex>
        <List.Title>If you realized that you only had a few years to live, how would you like to spend those years?</List.Title>
        <Flex even stack>
          <Edit name="5" />
          <Edit name="6" />
        </Flex>
        <h4>Make a list of the most important things you can think of that would give you a life of joy, passion, and fulfillment:</h4>
        <List.Title>When my Career is ideal, I am being/doing/having</List.Title>
        <Edit name="7" />
        <List.Title>When my Business is ideal, I am being/doing/having</List.Title>
        <Edit name="8" />
        <List.Title>When my Finances are ideal, I am being/doing/having</List.Title>
        <Edit name="9" />
        <List.Title>When my Health is ideal, I am being/doing/having</List.Title>
        <Edit name="10" />
        <List.Title>When my Relationships are ideal, I am being/doing/having</List.Title>
        <Edit name="11" />
      </List>
    </Form>
  );
}
